<template>
  <div class="consumer-offers">
    <pre-script-overlay :overlayType="'offers'" v-if="consumerLoaded && !needsAreaOfStudy && isValid && consumerValidated"></pre-script-overlay>
    <SubjectSelection v-if="consumerLoaded && needsAreaOfStudy" @saved-subjects="subjectsReady"></SubjectSelection>
    <div class="row" v-if="consumerLoaded && !needsAreaOfStudy && checkOffersloaded">
      <div class="col-8">
        <OfferManager :search-request-info="searchRequestInfo" :new-offers-found="newOffersFound" :offers="offers"
                      :submitted-offers="successfulSubmitIds" :successful-offers="successfulSubmits" :pending-submits="pendingSubmits" :pending-offers="pendingOffers" :wait="wait" :loading="loadingOffers"
                      :change-tab="forceChangeTab" :bulk-submit="useBulkSubmission" @submit-offer="submitOffer" @expired="expired"
                      @skip-offer="skipOffer" @refresh-offers="reload" @search-offers="searchOffers" @open-bulk-submit="submitBulk"
                      :search-new-offers-stopped="searchNewOffersStopped" :search-new-offers-started="searchNewOffersStarted"></OfferManager>
      </div>
      <div class="col-4">
        <RightOffersPanel :skipped-offers="skipped" @unskipOffer="unskipOffer" @submitAll="submitBulk" @cancelOffer="cancelBulkOffer"></RightOffersPanel>
      </div>
    </div>
    <div class="row loading-row" v-if="!(consumerLoaded && !needsAreaOfStudy && checkOffersloaded)">
      <div class="loading-text">Please wait as we are processing the information.</div>
      <img :src="loadingImg" />
    </div>
    <BulkSubmitOverlay :open="openBulkSubmit" @submitOffers="finishSubmitBulk" @cancelOffer="cancelBulkOffer"></BulkSubmitOverlay>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import PortalFetchJson from '@/js/PortalFetchJson'
import PortalPostJson from '@/js/PortalPostJson'
import OfferManager from '@/components/OfferManager.vue'
import RightOffersPanel from '@/components/RightOffersPanel.vue'
import SubjectSelection from '@/components/SubjectSelection.vue'
import PreScriptOverlay from '../components/PreScriptOverlay.vue'
import BulkSubmitOverlay from '@/components/BulkSubmitOverlay.vue'

export default {
  name: 'ConsumerOffers',
  props: ['consumerId', 'subjectsSelected'],
  components: {
    BulkSubmitOverlay,
    OfferManager,
    RightOffersPanel,
    SubjectSelection,
    PreScriptOverlay
  },
  data () {
    return {
      allOffers: [],
      streamingOffers: [],
      skippedOffers: [],
      offersloaded: false,
      loadingOffers: false,
      externalOffersLoaded: false,
      wait: false,
      loadingImg: process.env.BASE_URL + 'loading.gif',
      isValid: true,
      forceChangeTab: false,
      openBulkSubmit: false,
      finishedBulkSubmits: 0,
      backButton: false,
      searchRequestInfo: {},
      searchOfferCount: 0,
      newOffersFound: false,
      newSearchOffers: [],
      searchNewOffersStarted: undefined,
      searchNewOffersStopped: false,
      streamingTimeoutReached: false,
      consumerValidated: false,
      search_guid: ''
    }
  },
  methods: {
    async loadConsumerOrContinue (id) {
      await this.validateConsumer()
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      } else {
        this.load()
      }
    },
    load () {
      if (!this.isValid) {
        return
      }
      if (!this.needsAreaOfStudy) {
        this.$router.push(`/consumer/${this.consumerId}/offers`)
      }
      if (!this.offersloaded && !this.loadingOffers) {
        this.loadingOffers = true
        this.checkLoadedOffers()
        this.search_guid = this.guid
        this.loadOffers(this.search_guid)
        this.loadExternalOffers(this.search_guid)
      }
    },
    reload () {
      if (!this.loadingOffers) {
        this.allOffers = []
        this.offersloaded = false
        this.externalOffersLoaded = false
        this.loadingOffers = true
        this.search_guid = this.guid
        this.loadOffers(this.search_guid)
        this.loadExternalOffers(this.search_guid)
      }
    },
    searchOffers () {
      if (!this.loadingOffers) {
        this.newOffersFound = false
        this.loadingOffers = true
        this.allOffers.forEach((offer) => {
          offer.newOffer = false
        })
        this.loadSearchOffers(true)
      }
    },
    async expired (offerInfo) {
      var offer = this.allOffers.find((offer) => offer.displayedOfferId === offerInfo.displayedOfferId)
      if (!this.loadingOffers && !offer.newOffer) {
        this.reSearchOffers(offerInfo)
      }
    },
    async loadSearchOffers (newOffers) {
      this.waitOnOffers()
      var searchOffer = []
      this.newSearchOffers.forEach((search) => {
        this.processOfferResponse(search, newOffers)
        searchOffer.push(...search.extra_offers)
      })
      searchOffer.push(...this.streamingOffers)
      this.allOffers.push(...this.streamingOffers)
      this.streamingOffers = []
      this.searchRequestInfo = { offers: searchOffer }
      this.newSearchOffers = []
      this.loadingOffers = false
      this.endWaitOnOffers()
    },
    async reSearchOffers (offerInfo) {
      this.waitOnOffers()
      var offerResponse = await PortalFetchJson(`timed_out_offer_searches?consumer_id=${this.consumerId}&offer_id=${offerInfo.offerId}`)
      this.processOfferResponse(offerResponse)
      this.loadingOffers = false
      if (offerInfo.displayedOfferId !== '') {
        var offerIndex = this.allOffers.findIndex((offer) => offer.displayedOfferId === offerInfo.displayedOfferId)
        this.allOffers.splice(offerIndex, 1)
      }
      this.endWaitOnOffers()
    },
    async loadOffers (guid) {
      this.waitOnOffers()
      var offerResponse = await PortalFetchJson(`offers?search_guid=${guid}&consumer_id=${this.consumerId}&agent_id=${this.consumer.agent_id}&dialer_session_id=${this.consumer.dialer_session_id ?? ''}&subid=${this.consumer.subid ?? ''}&subid2=${this.consumer.subid2 ?? ''}&subid3=${this.consumer.subid3 ?? ''}&subid4=${this.consumer.subid4 ?? ''}&pub_transaction_id=${this.consumer.pub_transaction_id ?? ''}`)
      this.processOfferResponse(offerResponse)
      this.offersloaded = true
      this.finishLoadingOffers()
    },
    async loadExternalOffers (guid) {
      var offerResponse = await PortalFetchJson(`extra_offers?search_guid=${guid}&consumer_id=${this.consumerId}&agent_id=${this.consumer.agent_id}&dialer_session_id=${this.consumer.dialer_session_id ?? ''}&subid=${this.consumer.subid ?? ''}&subid2=${this.consumer.subid2 ?? ''}&subid3=${this.consumer.subid3 ?? ''}&subid4=${this.consumer.subid4 ?? ''}&pub_transaction_id=${this.consumer.pub_transaction_id ?? ''}`)
      this.processOfferResponse(offerResponse)
      this.externalOffersLoaded = true
      this.finishLoadingOffers()
    },
    finishLoadingOffers () {
      if (!this.offersloaded || !this.externalOffersLoaded || this.openBulkSubmit) {
        return
      }
      if (this.backButton && this.successfulSubmits.filter((o) => o.offer.exclusive).length > 0) {
        this.$router.push(`/consumer/${this.consumerId}/success`)
      }
      if (this.allOffers.length < 1) {
        if (this.consumer.search_button && this.searchNewOffersStarted !== false) {
          return
        } else {
          if (this.previousSubmits.length > 0) {
            this.$router.push(`/consumer/${this.consumerId}/success`)
          } else {
            this.$router.push(`/consumer/${this.consumerId}/no-offers`)
          }
        }
      }
      this.loadingOffers = false
      this.endWaitOnOffers()
    },
    processOfferResponse (offerResponse, newOffers = false) {
      if (!(this.$route.name === 'Consumer Offers' || this.$route.name === 'Consumer Subject Select')) {
        return
      }
      var responseTime = Date.now()
      var offers = offerResponse.offers || offerResponse.extra_offers
      var availableOffers = this.allOffers.length
      offers.forEach((offer) => {
        if (this.previousSubmits.some((submit) => (submit.offer.id === offer.id || submit.offer.id === offer.offer_id) && (submit.externalNameId === offer.offer_external_name_ids ||
          (Array.isArray(submit.externalNameId) && Array.isArray(offer.offer_external_name_ids) && submit.externalNameId.some((eni) => offer.offer_external_name_ids.includes(eni)))))) {
          return
        }
        var formattedOffer = {
          id: offer.offer_id ?? offer.id,
          name: offer.name,
          campaignId: offer.campaign_id,
          displayId: offer.display_offer_id,
          division: offer.division,
          exclusive: offer.exclusive,
          newOffer: newOffers,
          formId: offer.form_id,
          isWt: offer.is_warm_transfer,
          logoURL: offer.logo_url,
          shortDescription: offer.short_description,
          longDescription: offer.long_description,
          offerType: offer.offer_type,
          sequence: offer.sequence,
          offerExternalNameId: offer.offer_external_name_id,
          externalNameId: Array.isArray(offer.offer_external_name_ids) ? offer.offer_external_name_ids : [offer.offer_external_name_ids],
          externalNameGroup: offer.external_offer_name_group,
          dupFieldOfferId: offer.dup_field_offer_id,
          expiresAt: offer.expires_in ? responseTime + offer.expires_in : false,
          offerExternalInfoId: offer.offer_external_info_id,
          displayedOfferId: offer.displayed_offer_id,
          isExternalApi: !offerResponse.offers,
          priority: offer.priority,
          pingOnShow: offer.ping_on_show
        }
        if (offer.division === 2) {
          formattedOffer.isExtra = true
        }
        if (!offer.form_id) {
          var formFields = offer.form_field_ids.map((id) => offerResponse.form_fields.find((field) => field.id === id))
          formattedOffer.formFields = formFields
          formattedOffer.formListItems = offerResponse.form_list_items.filter((item) => formFields.some((field) => field.form_list_item_ids.includes(item.id)))
        }
        formattedOffer.programs = []
        formattedOffer.subjects = []
        offerResponse.programs.forEach((program, index) => {
          if (offer.program_ids.includes(program.id) && offerResponse.programs.findIndex((p) => p.id === program.id) === index) {
            formattedOffer.programs.push(program)
            if (program.subject_id && !formattedOffer.subjects.some((subject) => subject.id === program.subject_id)) {
              formattedOffer.subjects.push(offerResponse.subjects.find((subject) => subject.id === program.subject_id))
            }
          }
        })
        formattedOffer.campuses = offerResponse.campuses.filter((campus, index) => offer.campus_ids.includes(campus.id) && offerResponse.campuses.findIndex((c) => c.id === campus.id) === index)
        formattedOffer.schoolType = formattedOffer.campuses.some((campus) => campus.school_type_id === 1)
          ? formattedOffer.campuses.some((campus) => campus.school_type_id === 2) ? 'both' : 'online' : 'campus'
        if (offer.is_warm_transfer) {
          if (offer.warm_transfer_id) {
            formattedOffer.wtId = offer.warm_transfer_id
            formattedOffer.wtScript = offerResponse.warm_transfers ? offerResponse.warm_transfers.find((wt) => wt.id === offer.warm_transfer_id)?.script : null
          } else {
            formattedOffer.wtId = offer.warm_transfer && offer.warm_transfer[0] ? offer.warm_transfer[0].id : null
            formattedOffer.wtScript = offer.warm_transfer && offer.warm_transfer[0] ? offer.warm_transfer[0].script : null
          }
        }
        var skippedIndex = this.skippedOffers.findIndex((skipped) => skipped.externalNameId === formattedOffer.externalNameId && skipped.id === formattedOffer.id)
        if (skippedIndex >= 0) {
          formattedOffer.skipReason = this.skippedOffers[skippedIndex].skipReason
          this.skippedOffers.splice(skippedIndex, 1, formattedOffer)
        } else {
          if (!this.consumer.search_button) {
            this.allOffers.push(formattedOffer)
          } else if (newOffers) {
            this.allOffers.push(formattedOffer)
          } else if (!this.streamingTimeoutReached) {
            this.allOffers.push(formattedOffer)
          } else if (!this.offersLoaded && !this.externalOffersLoaded) {
            this.allOffers.push(formattedOffer)
          } else if ((this.offersLoaded || this.externalOffersLoaded) && availableOffers === 0) {
            this.allOffers.push(formattedOffer)
          } else {
            this.streamingOffers.push(formattedOffer)
          }
        }
      })
      if (this.streamingOffers.length > 0) {
        this.newOffersFound = true
      }
    },
    async submitOffer (submitObject) {
      if (this.waitForOfferSubmit) {
        return
      }
      submitObject.leadRequest.consumer_id = this.loadedId
      var wrappedRequest = {
        lead_request: submitObject.leadRequest
      }
      var offerIndex = this.allOffers.findIndex((offer) => offer.id === submitObject.offer.id && offer.displayedOfferId === submitObject.offer.displayedOfferId)

      if (this.useBulkSubmission && !submitObject.offer.isWt) {
        this.addPendingBulkSubmit(submitObject)
        this.allOffers.splice(offerIndex, 1)
        this.forceChangeTab = !this.forceChangeTab
        if (this.pendingBulkSubmits.length === this.consumer.max_offer_submission - this.successfulSubmitIds.length || submitObject.offer.exclusive) {
          this.submitBulk()
        }
      } else {
        this.toggleWaitForOfferSubmit()
        if (this.successfulSubmitIds.length + this.pendingSubmits.length > this.consumer.max_offer_submission - 2 || submitObject.offer.isWt || submitObject.offer.exclusive) {
          this.wait = true
        }
        this.addPendingLeadRequest(submitObject.offer)
        this.allOffers.splice(offerIndex, 1)
        var results = await PortalPostJson('lead_requests', wrappedRequest)
        var campus = submitObject.offer.campuses.find((campus) => campus.id === submitObject.leadRequest.raw_request.lead_education.campus_id)
        var program = submitObject.offer.programs.find((program) => program.id === submitObject.leadRequest.raw_request.lead_education.program_id)

        var submittedOffer = {
          id: submitObject.offer.id,
          offer: submitObject.offer,
          offerId: submitObject.offer.id,
          externalNameId: Array.isArray(submitObject.offer.externalNameId) ? submitObject.offer.externalNameId : [submitObject.offer.externalNameId],
          externalNameGroup: submitObject.offer.externalNameGroup,
          dupFieldOfferId: submitObject.offer.dupFieldOfferId,
          offerExternalNameId: submitObject.offer.offerExternalNameId,
          campusName: campus === undefined ? '' : campus.name,
          programName: program === undefined ? '' : program.name,
          status: results.errors ? 'Rejected' : results.lead_request.status,
          errors: results.errors
        }
        this.removePendingLeadRequest(submitObject.offer)
        this.addLeadRequest(submittedOffer)
        this.wait = false
        this.toggleWaitForOfferSubmit()
        var totalAvailableOffers = this.successfulSubmitIds.length > 0 ? this.allOffers.filter((o) => !o.exclusive).length : this.allOffers.length

        if (this.consumer.max_offer_submission === this.successfulSubmitIds.length || (submittedOffer.status !== 'Rejected' && (submittedOffer.offer.isWt || submittedOffer.offer.exclusive))) {
          this.$router.push(`/consumer/${this.consumerId}/success`)
        }

        if (totalAvailableOffers < 1) {
          if (this.newOffersFound) {
            this.searchOffers()
          } else {
            if (!this.searchNewOffersStarted) {
              this.$router.push(`/consumer/${this.consumerId}/success`)
            }
          }
        } else {
          this.forceChangeTab = !this.forceChangeTab
        }
      }
    },
    skipOffer (skipInfo) {
      var offerIndex = this.allOffers.findIndex((offer) => offer.displayedOfferId === skipInfo.displayedOfferId)
      var skipped = this.allOffers.splice(offerIndex, 1)[0]
      skipped.skipReason = skipInfo.reason
      this.skippedOffers.push(skipped)
      if (this.allOffers.length < 1) {
        if (this.newOffersFound) {
          this.searchOffers()
        } else {
          if (!this.searchNewOffersStarted) {
            if (this.previousSubmits.length > 0) {
              this.$router.push(`/consumer/${this.consumerId}/success`)
            } else {
              this.$router.push(`/consumer/${this.consumerId}/no-offers`)
            }
          }
        }
      }
    },
    unskipOffer (skippedOffer) {
      var offerIndex = this.skippedOffers.findIndex((offer) => offer.displayedOfferId === skippedOffer.displayedOfferId)
      this.skippedOffers.splice(offerIndex, 1)
      this.allOffers.push(skippedOffer)
    },
    resetToSubjectSelect () {
      this.allOffers = []
      this.offersloaded = false
      this.loadConsumerOrContinue(this.consumerId)
    },
    async subjectsReady () {
      await this.$router.push(`/consumer/${this.consumerId}/offers`)
    },
    async validateConsumer () {
      var validationResults = await PortalFetchJson(`consumer_validations?consumer_id=${this.consumerId}`)
      if (!validationResults.consumer_validation.valid) {
        this.isValid = false
        validationResults.consumer_validation.error_messages.forEach((error) => {
          this.addConsumerError({ type: 'HiddenFieldError', field: error.field, errorMsg: error.message })
        })
        this.$router.push(`/consumer/${this.consumerId}/not-valid`)
      }
      this.consumerValidated = true
    },
    submitBulk () {
      this.openBulkSubmit = true
    },
    finishSubmitBulk () {
      this.toggleSubmittingBulk()
      if (this.pendingBulkSubmits.length >= this.consumer.max_offer_submission - this.successfulSubmitIds.length) {
        this.wait = true
      }
      this.toggleWaitForOfferSubmit()
      this.openBulkSubmit = false
      this.finishedBulkSubmits = 0
      var vue = this
      this.pendingBulkSubmits.forEach((submitObject) => {
        submitObject.leadRequest.consumer_id = vue.loadedId
        var wrappedRequest = {
          lead_request: submitObject.leadRequest
        }
        PortalPostJson('lead_requests', wrappedRequest).then((results) => {
          var submittedOffer = {
            id: submitObject.offer.id,
            offer: submitObject.offer,
            offerId: submitObject.offer.id,
            externalNameId: Array.isArray(submitObject.offer.externalNameId) ? submitObject.offer.externalNameId : [submitObject.offer.externalNameId],
            status: results.errors ? 'Rejected' : results.lead_request.status,
            errors: results.errors,
            externalNameGroup: submitObject.offer.externalNameGroup,
            dupFieldOfferId: submitObject.offer.dupFieldOfferId,
            offerExternalNameId: submitObject.offer.offerExternalNameId
          }
          vue.addLeadRequest(submittedOffer)
          vue.finishedBulkSubmits++
          if (vue.finishedBulkSubmits === vue.pendingBulkSubmits.length) {
            vue.wait = false
            vue.toggleWaitForOfferSubmit()
            vue.toggleSubmittingBulk()
            vue.resetPendingBulk()
            var totalAvailableOffers = vue.successfulSubmitIds.length > 0 ? vue.allOffers.filter((o) => !o.exclusive).length : vue.allOffers.length

            if (vue.consumer.max_offer_submission === vue.successfulSubmitIds.length || (submittedOffer.status !== 'Rejected' && (submittedOffer.offer.isWt || submittedOffer.offer.exclusive))) {
              vue.$router.push(`/consumer/${vue.consumerId}/success`)
            }

            if (totalAvailableOffers < 1) {
              if (this.newOffersFound) {
                this.searchOffers()
              } else {
                if (!this.searchNewOffersStarted) {
                  vue.$router.push(`/consumer/${vue.consumerId}/success`)
                }
              }
            } else {
              vue.forceChangeTab = !vue.forceChangeTab
            }
          }
        })
      })
    },
    searchNewOffers () {
      this.searchNewOffersStarted = true
      let searchForNewOffers
      const me = this
      async function triggerSearchNewOffers (consumerId) {
        searchForNewOffers = setInterval(() => {
          new Promise(function (resolve, reject) {
            var response = PortalFetchJson(`timed_out_offer_searches_found?search_guid=${me.search_guid}&consumer_id=${consumerId}`)
            me.searchOfferCount++
            resolve(response)
          }).then(response => {
            if (response.offers_found) {
              me.newOffersFound = true
              me.newSearchOffers.push(response)

              if (me.initOffersLoaded && me.allOffers.length < 1) {
                me.loadSearchOffers(false)
                me.finishLoadingOffers()
                me.newOffersFound = false
                me.newSearchOffers = []
              }
            }
            // Stop searching after no more request keys or 12 tries
            if (!response.request_keys || me.searchOfferCount >= 12) {
              me.searchNewOffersStarted = false
              clearInterval(searchForNewOffers)
              me.searchNewOffersStopped = true
              me.finishLoadingOffers()
            }
          })
        }, 10 * 1000)
      }

      triggerSearchNewOffers(this.consumerId)
    },
    checkLoadedOffers () {
      if (!this.consumer.search_button) {
        return
      }

      let checkLoadedOffersInterval
      const me = this
      async function triggercheckLoadedOffers () {
        checkLoadedOffersInterval = setInterval(() => {
          me.streamingTimeoutReached = true

          clearInterval(checkLoadedOffersInterval)
        }, me.consumer.streaming_timeout * 1000)
      }

      triggercheckLoadedOffers()
    },
    cancelBulkOffer (pendingSubmit) {
      this.removePendingBulkSubmit(pendingSubmit)
      this.allOffers.push(pendingSubmit.offer)
      if (this.pendingBulkSubmits.length < 1) {
        this.openBulkSubmit = false
      }
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    }),
    ...mapMutations({
      addLeadRequest: 'consumer/leadRequests/addLeadRequest',
      addPendingLeadRequest: 'consumer/leadRequests/addPendingLeadRequest',
      addPendingBulkSubmit: 'consumer/leadRequests/addPendingBulkSubmit',
      removePendingBulkSubmit: 'consumer/leadRequests/removePendingBulkSubmit',
      removePendingLeadRequest: 'consumer/leadRequests/removePendingLeadRequest',
      waitOnOffers: 'consumer/waitOnOffers',
      endWaitOnOffers: 'consumer/endWaitOnOffers',
      toggleSubmittingBulk: 'consumer/leadRequests/toggleSubmittingBulk',
      toggleWaitForOfferSubmit: 'consumer/leadRequests/toggleWaitForOfferSubmit',
      resetPendingBulk: 'consumer/leadRequests/removeAllPendingBulkSubmit',
      addConsumerError: 'consumer/addConsumerError'
    })
  },
  computed: {
    successfulSubmits () {
      return this.previousSubmits.filter((submit) => submit.status === 'Accepted' && submit.externalNameId)
    },
    successfulSubmitIds () {
      return [...this.successfulSubmits.map((submit) => submit.externalNameId)]
    },
    pendingOffers () {
      return this.useBulkSubmission ? [...this.pendingBulkSubmits.map((pbs) => pbs.offer)] : [...this.pendingLeadRequests]
    },
    pendingSubmits () {
      return this.useBulkSubmission ? [...this.pendingBulkSubmits.map((pbs) => pbs.offer.externalNameId)] : [...this.pendingLeadRequests.map((plr) => plr.externalNameId)]
    },
    offers () {
      return {
        warmTransfer: this.allOffers.filter((offer) => offer.isWt && !offer.isExtra),
        callVerified: this.allOffers.filter((offer) => !offer.isWt && !offer.isExtra),
        extra: this.allOffers.filter((offer) => offer.isExtra)
      }
    },
    skipped () {
      return {
        warmTransfer: this.skippedOffers.filter((offer) => offer.isWt && !offer.isExtra),
        callVerified: this.skippedOffers.filter((offer) => !offer.isWt && !offer.isExtra),
        extra: this.skippedOffers.filter((offer) => offer.isExtra)
      }
    },
    needsAreaOfStudy () {
      return this.consumer.show_area_study_page && !this.subjectsSelected
    },
    allSubjectIds () {
      if (this.consumer) {
        return this.subjectIds ? [...this.subjectIds, ...this.consumer.default_area_studies] : [...this.consumer.default_area_studies]
      }
      return []
    },
    maxOffersSelected () {
      return this.pendingBulkSubmits && this.pendingBulkSubmits.length === this.consumer.max_offer_submission - this.successfulSubmitIds.length
    },
    initOffersLoaded () {
      return this.offersloaded && this.externalOffersLoaded
    },
    checkOffersloaded () {
      if (this.consumer.search_button) {
        return this.offersloaded || this.externalOffersLoaded
      } else {
        return this.offersloaded
      }
    },
    guid () {
      return '0000-0000-0000'.replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16))
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      consumer: state => state.consumer.currentConsumer,
      subjectIds: state => state.consumer.additionalInfo.info.subject_ids,
      leadRequestsFull: state => state.consumer.leadRequests.leadRequestsFull,
      pendingLeadRequests: state => state.consumer.leadRequests.pendingLeadRequests,
      pendingBulkSubmits: state => state.consumer.leadRequests.pendingBulkSubmits,
      waitForOfferSubmit: state => state.consumer.leadRequests.waitForOfferSubmit
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      previousSubmits: 'consumer/leadRequests/getRequests',
      useBulkSubmission: 'consumer/useBulkSubmission'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.loadConsumerOrContinue(this.consumerId)
    }
    window.onpopstate = () => {
      this.backButton = true
    }
  },
  watch: {
    consumerId (val) {
      this.loadConsumerOrContinue(val)
    },
    loadedId () {
      this.load()
      if (this.leadRequestsFull) {
        this.$router.push(`/consumer/${this.consumerId}/success`)
      }
    },
    subjectsSelected (newVal) {
      if (!newVal) {
        this.resetToSubjectSelect()
      }
    },
    initOffersLoaded () {
      if (this.consumer.search_button) {
        this.searchNewOffers()
      }
    }
  }
}
</script>

<style scoped>
.loading-row {
  padding-top: 150px;
}
.loading-row img {
  height: 70px;
  width: auto;
  margin: auto;
}
.loading-text {
  text-align: center;
  margin: auto;
}
.processing-overlay {
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.7);
  text-align: center;
  padding-top: 30vh;
  font-size: 24px;
  color: white;
}
</style>
<style>
.offer-subject {
  height: fit-content;
  background-color: #5bc0de;
  color: white;
  border-radius: .25em;
  margin-right: 4px;
  margin-top: 2px;
  font-weight: 600;
  font-size: 10.5px;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
